import React, {Fragment } from 'react';
import { 
    FormDataConsumer,
    TextInput ,
} from 'react-admin';
import { useForm } from 'react-final-form';
import TableCell from '@material-ui/core/TableCell';


const getValidate=(val) => {
    let dummy= null;
    if(!val || parseInt(val,10) < 56 || parseInt(val,10) > 100){
        dummy = (document.getElementById("tx_pulse"))? document.getElementById("tx_pulse").setAttribute("style", "color: red;"): null;
    }else{
        dummy = (document.getElementById("tx_pulse"))?document.getElementById("tx_pulse").removeAttribute("style"):null;
    }
    
    return val
}

const OrderOrigin = ({ formData, ...rest }) => {
    const form = useForm();

    return (
        <Fragment>
             <TableCell >
                <TextInput 
                    id="tx_pulse"
                    source="pulse" 
                    label=""
                    onChange ={getValidate(formData.pulse),
                        formData.pulse = getValidate(formData.pulse) 
                    }
                    {...rest}
                    />
             </TableCell>          
        </Fragment>
    );
};
const Pulse = ({...props}) => (

    <FormDataConsumer>
        {formDataProps => (
            <OrderOrigin {...formDataProps} />
        )}
    </FormDataConsumer>
);

export default Pulse